<template>
  <v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
      <v-select
        v-bind:items="versions"
        v-model="questionnaire.version"
        label="Select"
        single-line
        bottom
      ></v-select>
      </v-flex>
      <v-flex class="mt-1" xs12 sm12 md12 lg8 offset-lg2>
        <v-carousel :cycle="false" v-model="actualItem" :light="true" hide-delimiters>
          <v-carousel-item v-for="item in 30" v-bind:src="''" :key="item"
                           reverse-transition="" transition="">
            <v-flex style="margin-left: 10%; margin-right: 10%">
              <v-card>
                <v-flex class="ma-4 pa-1">
                  <v-card >
                    <v-card-title>
                      <span style="float: left;"> {{actualItem + 1 }} / 30 </span>
                      <span style="margin-left: auto; margin-right: 0;"></span>
                    </v-card-title>
                    <v-card-title class="title" v-t="{path: 'ITEM'+item+'.TITLE', locale: questionnaire.version}">
                    </v-card-title>
                    <v-card-title>
                      <span class="subheading" style="margin-left: auto; margin-right: 0; cursor: pointer">
                  </span>
                    </v-card-title>
                  </v-card>
                </v-flex>

                <v-card-title>
                  <v-btn large color="primary" block v-on:click="showIncorporate(item)">
                    <span v-t="{path: 'info.incorporateDialog.BUTTON', locale: questionnaire.version}"></span>
                    <v-icon light small right>live_help</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-carousel-item>
        </v-carousel>
      </v-flex>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <div class="text-xs-center">
          <v-pagination length="30" v-model="paginationItem" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <evaloe-assist :questionnaire-items="this.questionnaireItems"
                   :version="this.questionnaire.version"
                   :incorporateHelp="this.incorporateHelp"
                   :incorporateKey="this.incorporateKey"
                   v-on:close="closeAssist"
    ></evaloe-assist>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
  </v-layout>
</template>

<script>
  import EvaloeAssist from '../questionnaires/EvaloeAssist.vue'
  export default {
    name: 'questionnaire-validator',
    data () {
      return {
        incorporateKey: null,
        incorporateHelp: false,
        actualItem: 0,
        questionnaire: {
          version: null
        },
        versions: [
          {text: 'Català', value: 'CA_QUESTIONNAIRE'},
          {text: 'Castellano', value: 'ES_QUESTIONNAIRE'}
        ]
      }
    },
    components: {
      'evaloe-assist': EvaloeAssist
    },
    methods: {
      showHelp: function (itemId) {
        this.dialogKey = itemId
        this.dialogHelp = true
      },
      showIncorporate: function (itemId) {
        this.incorporateKey = itemId
        this.incorporateHelp = true
      },
      closeAssist: function () {
        this.incorporateHelp = false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/QuestionnaireValidator.vue